export default __webpack_public_path__ + "static/media/sharkClosed.0bd39002.jpg";